import { graphql } from "react-relay";

export const loginUserMutation = graphql`
  mutation LoginUserMutation($input: LoginUserMutationInput!) {
    loginUser(input: $input) {
      clientMutationId
      verifyCodeResult
      verifyCodeMessage
      loginStatus
      operation
      orgOperation
      viewer {
        id
        user {
          id
          status
          emails
          givenName
          familyName
          externalImageUrl
          createdTime
          members {
            value
            scope {
              type
              value
            }
          }
          orgs(first: 1000000) {
            edges {
              node {
                primaryOrgCalendar
                primaryOrgEmail
                id
                experiments
                name
                createdTime
                userPerson {
                  ... on Person {
                    profile {
                      givenName
                      familyName
                      externalImageUrl
                    }
                  }
                }
                flowStates(first: 1000000) {
                  edges {
                    node {
                      flowKey
                      current {
                        state
                        percentComplete
                        errorMessage
                      }
                      pending {
                        state
                        percentComplete
                        errorMessage
                      }
                    }
                  }
                }
                workingGroups(first: 1000000) {
                  edges {
                    node {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
